import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getFileNameFromUrl } from "../../utils/urls";

const FileItem = ({ file, setShowModal, setSelectedFile }) => {
  return (
    <div className="file-item">
      <button
        type="button"
        onClick={() => {
          setSelectedFile(file);
          setShowModal(true);
        }}
        className="btn btn-link p-0 text-decoration-underline text-primary d-flex align-items-center"
        title="Click to view file"
      >
        <FontAwesomeIcon icon={faFilePdf} className="me-2" size="lg" />
        {getFileNameFromUrl(file)}
      </button>
    </div>
  );
};

export default FileItem;
